module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "toc"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fronttitle",
    attrs: {
      "id": "toc_p1"
    }
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "toc_p2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "toc_p3"
    }
  }, [_c('b', [_c('a', {
    attrs: {
      "href": "#/intro"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("INTRODUCTION")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "toc_p4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chap01"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('b', [_vm._v("ONE")]), _vm._v(" BONES OF CONTENTION")]), _c('br'), _vm._v("The American Incognitum and the Discovery of Extinction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "toc_p5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chap02"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('b', [_vm._v("TWO")]), _vm._v(" PARADISE LOST")]), _c('br'), _vm._v("Unraveling the Mysteries of Insular Species")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "toc_p6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('b', [_vm._v("THREE")]), _vm._v(" SOUNDING THE ALARM ABOUT"), _c('br'), _vm._v("CONTINENT-WIDE WILDLIFE EXTINCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "toc_p7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('b', [_vm._v("FOUR")]), _vm._v(" NATIONALISM, NOSTALGIA,"), _c('br'), _vm._v("AND THE CAMPAIGN TO SAVE THE BISON")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "toc_p8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('b', [_vm._v("FIVE")]), _vm._v(" GOING GLOBAL")]), _c('br'), _vm._v("The American Committee and the First Inventory of Extinction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "toc_p9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('b', [_vm._v("SIX")]), _vm._v(" THE LATIN AMERICAN TURN")]), _c('br'), _vm._v("Nature Protection in the Western Hemisphere")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "toc_p10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('b', [_vm._v("SEVEN")]), _vm._v(" ENTER ECOLOGY")]), _c('br'), _vm._v("Preserving Nature’s Living Laboratory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "toc_p11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('b', [_vm._v("EIGHT")]), _vm._v(" RECONSIDERING RAPTORS"), _c('br'), _vm._v("DURING THE INTERWAR YEARS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "toc_p12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('b', [_vm._v("NINE")]), _vm._v(" SALVATION THROUGH SCIENCE?")]), _c('br'), _vm._v("The First Life-History Studies of Endangered Species")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "toc_p13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('b', [_vm._v("TEN")]), _vm._v(" “THE NATION’S FIRST RESPONSIBILITY”")]), _c('br'), _vm._v("Saving Endangered Species in the Age of Ecology")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "toc_p14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/conc",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('b', [_vm._v("CONCLUSION")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "toc_p15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "toc_p16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/biblio",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Select Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "toc_p17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78a90703","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 69
// module chunks = 0